export default __webpack_public_path__ + "static/media/tenpenny.b792a514.png";